import React from "react";
import TeamMember from "./teamMember";

import teamAmy from "../../../assets/img/teamAmy.jpg";
import teamErin from "../../../assets/img/teamErin.jpg";
import teamJake from "../../../assets/img/teamJake.jpg";
import teamLeif from "../../../assets/img/teamLeif.jpg";
import teamMichael from "../../../assets/img/teamMichael.jpg";
import teamRusty from "../../../assets/img/teamRusty.jpg";
import teamShane from "../../../assets/img/teamShane.jpg";
import teamStephen from "../../../assets/img/teamStephen.jpg";
import teamTom from "../../../assets/img/teamTom.jpg";
import teamAlex from "../../../assets/img/teamAlex.jpg";

export default function TeamMembers() {
  // see aboutStrings ('../../strings/about') for the job description path

  return (
    <>
      <TeamMember name="MICHAEL" favorite="true-colors-color-theory" artwork={teamMichael} job="team.jobs.design.1" />

      <TeamMember name="AMY" favorite="dolch_sight_word_spelling" artwork={teamAmy} job="team.jobs.design.0" />

      <TeamMember
        name="ERIN"
        favorite="parts-of-speech-quest-prepositions"
        artwork={teamErin}
        job="team.jobs.design.2"
      />

      <TeamMember name="JAKE" favorite="zero_sum" artwork={teamJake} job="team.jobs.development.2" />

      <TeamMember name="RUSTY" favorite="fuzzbug_fuzzathlon" artwork={teamRusty} job="team.jobs.development.1" />

      <TeamMember name="TOM" favorite="multiplication_mine" artwork={teamTom} job="team.jobs.development.0" />

      <TeamMember
        name="LEIF"
        favorite="recipe-remix-converting-volume"
        artwork={teamLeif}
        job="team.jobs.development.0"
      />

      <TeamMember name="STEPHEN" favorite="zero_sum" artwork={teamStephen} job="team.jobs.development.0" />

      <TeamMember name="SHANE" favorite="order_of_operations" artwork={teamShane} job="team.jobs.development.1" />

      <TeamMember name="ALEX" favorite="rih" artwork={teamAlex} job="team.jobs.development.0" />
    </>
  );
}
